// src/hooks/User/useUserFilters.js
import { useState, useMemo } from 'react';

export const useUserFilters = (allUsers) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterDepartment, setFilterDepartment] = useState('all');
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const departments = useMemo(() => {
    if (!allUsers || !Array.isArray(allUsers)) return ['all'];
    return ['all', ...new Set(allUsers.map(user => user.user_department).filter(Boolean))];
  }, [allUsers]);

  const filteredUsers = useMemo(() => {
    if (!allUsers || !Array.isArray(allUsers)) return [];
    
    return allUsers.filter(user => {
      const matchesSearch = 
        user.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.user_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.user_phone?.includes(searchTerm) ||
        user.user_roll?.toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesStatus = filterStatus === 'all' || user.status === filterStatus;
      const matchesDepartment = filterDepartment === 'all' || user.user_department === filterDepartment;
      
      return matchesSearch && matchesStatus && matchesDepartment;
    });
  }, [allUsers, searchTerm, filterStatus, filterDepartment]);

  return {
    searchTerm,
    setSearchTerm,
    filterStatus,
    setFilterStatus,
    filterDepartment,
    setFilterDepartment,
    isFilterOpen,
    setIsFilterOpen,
    filteredUsers,
    departments
  };
};